module.exports = __webpack_public_path__ + "static/media/rise.7c1ec6a4.mp3";